
<script>

import Navbar from '@/components/Navbar'
import htmlEn from '@/assets/generated/p1.en.html'
import htmlDe from '@/assets/generated/p1.de.html'

export default {
  name: 'p1',
  components: { Navbar },
  computed: {
    raw3(){
      return this.$i18n.locale === 'de' ? htmlDe : htmlEn;
    }
  }
}
</script>


<template>
  <div>
  <navbar :lightTheme="true" :blogpost="true" />
<div id="raw" v-html="raw3"></div>
  </div>
<!--
  <MyFooter />
<p>Using v-html directive: <span v-html="raw3"></span></p>


  <button @click="log">{{ msg }}</button>
  <div>{{ raw3 }}</div>
<template src="@/assets/generated/gdpr.html"></template>
-->
</template>


<style scoped>
  @import "@/assets/css/fcc.scss"; 
</style>
